import React, {useEffect, useMemo} from 'react';
import {Box, Grid} from '@mui/material';
import {AutoField} from '../../../components/AutoForm/AutoFieldNew';
import {OVRecommendation_pots} from '../../../schema-types/OVRecommendation';
import {Pot} from '../../../schema-types/Pot';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {
  transferSourceType,
  transferFullField as fullField,
  transferInSpecieSourceField as inSpecieSourceField,
  transferAmountField as recommendAmountField,
} from './transferFields';
import type {newPlanFields} from '../RecommendsSetUpNew/setUpNewFields';
import {InitialFeeField} from '../CreateRecommend/InitialFeesField';
import {useAutoField} from '../../../components/AutoForm/useAutoForm';
import {
  setTransferFullAmount,
  deriveIsLisaTransferSource,
  useSetTransferFullAmount,
  useDeriveIsLisaTransferSource,
} from '../hooks/transferHooks';

export interface TransferPlanProps {
  id?: string;
  maxAmount?: number;
  // eslint-disable-next-line react/no-unused-prop-types
  index?: number;
  // eslint-disable-next-line react/no-unused-prop-types
  pot: Pot;
  hasInSpecie?: boolean;
}

export const getRecommendDetailsPot = (id: string, pots: OVRecommendation_pots[]) =>
  pots?.find((p) => p?.pot?.id === id);

export const TransferSourceForm = ({
  id,
  maxAmount,
  hasInSpecie = true,
}: TransferPlanProps) => {
  const [transferSourceField] = useAutoField<transferSourceType | undefined>(
    `transfer.transferSources[${id!}]`
  );
  useSetTransferFullAmount({id: id!, maxAmount});
  const isLisaDestination = useDeriveIsLisaTransferSource();

  return (
    <>
      <Grid item xs={12}>
        <Box>
          <Grid container direction="column" spacing={4}>
            <Grid item>
              <Grid alignItems="center" container direction="row" spacing={2}>
                <Grid item xs={6}>
                  <InitialFeeField
                    formikKeyPrefixWithoutFee={`transfer.transferSources.${id}`}
                    disabled={isLisaDestination} // No Initial fee on transferring into a LISA
                  />
                </Grid>
                {hasInSpecie && (
                  <Grid item xs={6}>
                    <AutoField
                      field={{
                        ...inSpecieSourceField,
                        id: `transfer.transferSources.${id}.inSpecie`,
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      ...fullField,
                      id: `transfer.transferSources.${id}.full`,
                      // disabled: !transferSourceField.value?.maxAmount || true,
                      label: 'Full transfer?',
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <AutoField
                    field={{
                      ...recommendAmountField,
                      disabled: transferSourceField.value?.full || false,
                      label: 'Transfer amount',

                      id: `transfer.transferSources.${id}.singleClientAmount`,
                    }}
                    disabled={transferSourceField.value?.full}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </>
  );
};
